import React from 'react';
import './StatusChip.scss';

export const statusConfig = [
  { label: "Pending", value: "pending", color: "#EEEB1E" },
  { label: "Submitted", value: "submitted", color: "#FFA500" },
  { label: "Request Dismissal", value: "req_dismissal", color: "#355C9D" },
  { label: "Overdue", value: "overdue", color: "#808080" },
  { label: "Docs Required", value: "docs_required", color: "#ED7047" },
  { label: "Rejected", value: "rejected", color: "#E62B2A" },
  { label: "Violation Removed", value: "vio_removed", color: "#11B50C" },
  { label: "Defect Status", value: "defect_status", color: "#9B59B6" },
  { label: "Abatement Required", value: "abate_req", color: "#F39C12" },
  { label: "Abatement In Progress", value: "abate_prog", color: "#2980B9" },
  { label: "Inspection Requested", value: "insp_req", color: "#16A085" },
  { label: "Inspection Scheduled", value: "insp_scheduled", color: "#2ECC71" },
  { label: "Owner Affidavit Required", value: "o_affidavit_req", color: "#34495E" },
  { label: "Vendor Docs", value: "vendor_docs", color: "#E67E22" },
  { label: "Registration Expired", value: "reg_expired", color: "#C0392B" },
  { label: "Tenant Denied Access", value: "t_denied_access", color: "#7F8C8D" },
];

const StatusChip = ({ status }) => {
  return (
    <div
      className="status-chip"
      style={{ backgroundColor: statusConfig.find(item => item.value === status)?.color || "#808080" ,lineHeight: "13px"}}
    >
      {statusConfig.find(item => item.value === status)?.label || status}
    </div>
  );
};

export default StatusChip; 